require('./grayscale');

$(function () {
    if ($('.top-code').length > 0) {
        var qrcode = new QRCode(document.getElementsByClassName('top-code')[0], {
            width: 124,
            height: 124
        });
        var url = $('.top-code').data('url');
        qrcode.makeCode(url);
    }

    $('.top-tab-nav-item-tv').hover(function () {
        if ($('.top-tv').css('display') != 'block') {
            $('.top-tv').slideDown('fast');
        }
    }, function () {
    });

    $('.top-tv').hover(function () {
    }, function () {
        $('.top-tv').slideUp('fast');
    });

    $('.top-tab-nav-item').hover(function () {
        if (!$(this).hasClass('top-tab-nav-item-tv')) {
            $('.top-tv').slideUp('fast');
        }
    }, function () {
    });

    $('.top-download-btn').on('click', function () {
        if ($('.top-code').css('display') == 'block') {
            $('.top-code').css('display', 'none');
        } else {
            $('.top-code').css('display', 'block');
        }
    });

    $('.top-user').hover(function () {
        $('.dropdown-list').show();
    }, function () {
        setTimeout(function () {
            $('.dropdown-list').hide();
        }, 2000);

    });
    $('.top-tab-newspaper').on('click', function () {
        if ($('.top-tab-newspaper-content').css('display') == 'block') {
            $('.top-tab-newspaper-content').css('display', 'none');
        } else {

            $('.top-tab-newspaper-content').css('display', 'block');
            // $('.top-search-box-input').focus();
        }
    });
    // $('.top-search').on('click', function () {
    //     if ($('.top-search-box').css('display') == 'block') {
    //         $('.top-search-box').css('display', 'none');
    //     } else {
    //         changeSeachPos();
    //         $('.top-search-box').css('display', 'block');
    //         $('.top-search-box-input').focus();
    //     }
    // });
    //
    // var isHoverClear = false;
    // $('.top-search-box-input').blur(function () {
    //     if (!isHoverClear) {
    //         $('.top-search-box').hide();
    //     }
    // });
    //
    // $('.top-search-box-btn').click(function () {
    //     $('.top-search-box-input').val('');
    //     $('.top-search-box-input').focus();
    // });
    //
    // $('.top-search-box-btn').hover(function () {
    //     isHoverClear = true;
    // }, function () {
    //     isHoverClear = false;
    // });
    //
    $('.top-search-box-input').bind('keypress', function (event) {
        if (event.keyCode == '13') {
            var keyword = $.trim($('.top-search-box-input').val());
            location.href = '/search?key=' + keyword;
        }
    });
    $('.top-search-box-btn').click(function () {
        var keyword = $.trim($('.top-search-box-input').val());
        location.href = '/search?key=' + keyword;
    });
    $('.qrcode-box').on('click', function () {
        $('.qrcode-img').not($(this).find('.qrcode-img')).hide()
        if ($(this).find('.qrcode-img').css('display') == 'none') {
            $(this).find('.qrcode-img').css('display', 'block')
        } else {
            $(this).find('.qrcode-img').css('display', 'none')
        }
    })
    // 顶部导航子栏目控制
    $('.father-column').on('click', function () {
        console.log($(this).attr('id'));
        $('#' + $(this).attr('id') + '-children-tab').siblings().hide()
        $('#' + $(this).attr('id') + '-children-tab').css('display', 'flex')

        if ($(this).attr('id') == $('.children-column-box').attr('id')) {
            if ($('.children-column-box').css('display') == 'none') {
                $('.children-column-box').css('display', 'block')
            } else {
                $('.children-column-box').css('display', 'none')
            }
        }
        else {
            $('.children-column-box').attr('id', $(this).attr('id'))
            $('.children-column-box').css('display', 'block')
        }
    })
    // window.onload = function () {
    //     changeSeachPos();
    // };
    // window.onresize = function () {
    //     changeSeachPos();
    // };
    //
    // function changeSeachPos() {
    //     // var top = $('.top-search').offset().top;
    //     var left = $('.top-search').offset().left;
    //
    //     // $('.top-search-box').css('top', top + 14);
    //     $('.top-search-box').css('left', left - 250);
    // }

    window.onscroll = function () {
        var top = document.documentElement.scrollTop || document.body.scrollTop;
        // if (top >= 72) {
        //     $('.top').height(60);
        //     $('.top-tab-nav-item').css('line-height', '60px');
        //     $('.top-tab-nav-item-tv').css('background-position-y', '30px');
        // } else {
        //     $('.top').height(60);
        //     $('.top-tab-nav-item').css('line-height', '60px');
        //     $('.top-tab-nav-item-tv').css('background-position-y', '35px');
        // }
    };
});


//////////////////
// WEBPACK FOOTER
// ./share/client/js/top.js
// module id = 24
// module chunks = 0